/* Some dummy data retrieved from https://developer.spotify.com/console/get-album/ about "thank u, next" album by Arianna Grande */
export default {
  album_type: 'album',
  artists: [
    {
      external_urls: {
        spotify: 'https://open.spotify.com/artist/66CXWjxzNUsdJxJ2JdwvnR',
      },
      href: 'https://api.spotify.com/v1/artists/66CXWjxzNUsdJxJ2JdwvnR',
      id: '66CXWjxzNUsdJxJ2JdwvnR',
      name: 'Ariana Grande',
      type: 'artist',
      uri: 'spotify:artist:66CXWjxzNUsdJxJ2JdwvnR',
    },
  ],
  available_markets: [
    'AD',
    'AE',
    'AG',
    'AL',
    'AM',
    'AR',
    'AT',
    'AU',
    'AZ',
    'BA',
    'BB',
    'BD',
    'BE',
    'BG',
    'BH',
    'BI',
    'BO',
    'BR',
    'BS',
    'BT',
    'BW',
    'BZ',
    'CA',
    'CH',
    'CL',
    'CM',
    'CO',
    'CR',
    'CV',
    'CW',
    'CY',
    'CZ',
    'DE',
    'DK',
    'DM',
    'DO',
    'DZ',
    'EC',
    'EE',
    'EG',
    'ES',
    'FI',
    'FJ',
    'FM',
    'FR',
    'GA',
    'GB',
    'GD',
    'GE',
    'GH',
    'GM',
    'GN',
    'GQ',
    'GR',
    'GT',
    'GW',
    'GY',
    'HK',
    'HN',
    'HR',
    'HT',
    'HU',
    'ID',
    'IE',
    'IL',
    'IN',
    'IS',
    'IT',
    'JM',
    'JO',
    'JP',
    'KE',
    'KG',
    'KH',
    'KI',
    'KM',
    'KN',
    'KR',
    'KW',
    'KZ',
    'LA',
    'LB',
    'LC',
    'LI',
    'LK',
    'LR',
    'LS',
    'LT',
    'LU',
    'LV',
    'MA',
    'MC',
    'MD',
    'ME',
    'MH',
    'MK',
    'ML',
    'MN',
    'MO',
    'MR',
    'MT',
    'MV',
    'MW',
    'MX',
    'MY',
    'NA',
    'NE',
    'NG',
    'NI',
    'NL',
    'NO',
    'NR',
    'NZ',
    'OM',
    'PA',
    'PE',
    'PG',
    'PH',
    'PK',
    'PL',
    'PS',
    'PT',
    'PW',
    'PY',
    'QA',
    'RO',
    'RS',
    'RU',
    'RW',
    'SA',
    'SB',
    'SC',
    'SE',
    'SG',
    'SI',
    'SK',
    'SL',
    'SM',
    'SN',
    'SR',
    'ST',
    'SV',
    'SZ',
    'TD',
    'TG',
    'TH',
    'TL',
    'TN',
    'TO',
    'TR',
    'TT',
    'TV',
    'TW',
    'TZ',
    'UA',
    'UG',
    'US',
    'UY',
    'VC',
    'VN',
    'VU',
    'WS',
    'XK',
    'ZA',
    'ZW',
  ],
  copyrights: [
    {
      text: '© 2019 Republic Records, a division of UMG Recordings, Inc.',
      type: 'C',
    },
    {
      text: '℗ 2019 Republic Records, a division of UMG Recordings, Inc.',
      type: 'P',
    },
  ],
  external_ids: {
    upc: '00602577490385',
  },
  external_urls: {
    spotify: 'https://open.spotify.com/album/2fYhqwDWXjbpjaIJPEfKFw',
  },
  genres: [],
  href: 'https://api.spotify.com/v1/albums/2fYhqwDWXjbpjaIJPEfKFw',
  id: '2fYhqwDWXjbpjaIJPEfKFw',
  images: [
    {
      height: 640,
      url: 'https://i.scdn.co/image/ab67616d0000b27356ac7b86e090f307e218e9c8',
      width: 640,
    },
    {
      height: 300,
      url: 'https://i.scdn.co/image/ab67616d00001e0256ac7b86e090f307e218e9c8',
      width: 300,
    },
    {
      height: 64,
      url: 'https://i.scdn.co/image/ab67616d0000485156ac7b86e090f307e218e9c8',
      width: 64,
    },
  ],
  label: 'Republic Records',
  name: 'thank u, next',
  popularity: 91,
  release_date: '2019-02-08',
  release_date_precision: 'day',
  total_tracks: 12,
  tracks: {
    href: 'https://api.spotify.com/v1/albums/2fYhqwDWXjbpjaIJPEfKFw/tracks?offset=0&limit=50',
    items: [
      {
        artists: [
          {
            external_urls: {
              spotify: 'https://open.spotify.com/artist/66CXWjxzNUsdJxJ2JdwvnR',
            },
            href: 'https://api.spotify.com/v1/artists/66CXWjxzNUsdJxJ2JdwvnR',
            id: '66CXWjxzNUsdJxJ2JdwvnR',
            name: 'Ariana Grande',
            type: 'artist',
            uri: 'spotify:artist:66CXWjxzNUsdJxJ2JdwvnR',
          },
        ],
        available_markets: [
          'AD',
          'AE',
          'AG',
          'AL',
          'AM',
          'AR',
          'AT',
          'AU',
          'AZ',
          'BA',
          'BB',
          'BD',
          'BE',
          'BG',
          'BH',
          'BI',
          'BO',
          'BR',
          'BS',
          'BT',
          'BW',
          'BZ',
          'CA',
          'CH',
          'CL',
          'CM',
          'CO',
          'CR',
          'CV',
          'CW',
          'CY',
          'CZ',
          'DE',
          'DK',
          'DM',
          'DO',
          'DZ',
          'EC',
          'EE',
          'EG',
          'ES',
          'FI',
          'FJ',
          'FM',
          'FR',
          'GA',
          'GB',
          'GD',
          'GE',
          'GH',
          'GM',
          'GN',
          'GQ',
          'GR',
          'GT',
          'GW',
          'GY',
          'HK',
          'HN',
          'HR',
          'HT',
          'HU',
          'ID',
          'IE',
          'IL',
          'IN',
          'IS',
          'IT',
          'JM',
          'JO',
          'JP',
          'KE',
          'KG',
          'KH',
          'KI',
          'KM',
          'KN',
          'KR',
          'KW',
          'KZ',
          'LA',
          'LB',
          'LC',
          'LI',
          'LK',
          'LR',
          'LS',
          'LT',
          'LU',
          'LV',
          'MA',
          'MC',
          'MD',
          'ME',
          'MH',
          'MK',
          'ML',
          'MN',
          'MO',
          'MR',
          'MT',
          'MV',
          'MW',
          'MX',
          'MY',
          'NA',
          'NE',
          'NG',
          'NI',
          'NL',
          'NO',
          'NR',
          'NZ',
          'OM',
          'PA',
          'PE',
          'PG',
          'PH',
          'PK',
          'PL',
          'PS',
          'PT',
          'PW',
          'PY',
          'QA',
          'RO',
          'RS',
          'RU',
          'RW',
          'SA',
          'SB',
          'SC',
          'SE',
          'SG',
          'SI',
          'SK',
          'SL',
          'SM',
          'SN',
          'SR',
          'ST',
          'SV',
          'SZ',
          'TD',
          'TG',
          'TH',
          'TL',
          'TN',
          'TO',
          'TR',
          'TT',
          'TV',
          'TW',
          'TZ',
          'UA',
          'UG',
          'US',
          'UY',
          'VC',
          'VN',
          'VU',
          'WS',
          'XK',
          'ZA',
          'ZW',
        ],
        disc_number: 1,
        duration_ms: 212266,
        explicit: true,
        external_urls: {
          spotify: 'https://open.spotify.com/track/39LmTF9RgyakzSYX8txrow',
        },
        href: 'https://api.spotify.com/v1/tracks/39LmTF9RgyakzSYX8txrow',
        id: '39LmTF9RgyakzSYX8txrow',
        is_local: false,
        name: 'imagine',
        preview_url: null,
        track_number: 1,
        type: 'track',
        uri: 'spotify:track:39LmTF9RgyakzSYX8txrow',
      },
      {
        artists: [
          {
            external_urls: {
              spotify: 'https://open.spotify.com/artist/66CXWjxzNUsdJxJ2JdwvnR',
            },
            href: 'https://api.spotify.com/v1/artists/66CXWjxzNUsdJxJ2JdwvnR',
            id: '66CXWjxzNUsdJxJ2JdwvnR',
            name: 'Ariana Grande',
            type: 'artist',
            uri: 'spotify:artist:66CXWjxzNUsdJxJ2JdwvnR',
          },
        ],
        available_markets: [
          'AD',
          'AE',
          'AG',
          'AL',
          'AM',
          'AR',
          'AT',
          'AU',
          'AZ',
          'BA',
          'BB',
          'BD',
          'BE',
          'BG',
          'BH',
          'BI',
          'BO',
          'BR',
          'BS',
          'BT',
          'BW',
          'BZ',
          'CA',
          'CH',
          'CL',
          'CM',
          'CO',
          'CR',
          'CV',
          'CW',
          'CY',
          'CZ',
          'DE',
          'DK',
          'DM',
          'DO',
          'DZ',
          'EC',
          'EE',
          'EG',
          'ES',
          'FI',
          'FJ',
          'FM',
          'FR',
          'GA',
          'GB',
          'GD',
          'GE',
          'GH',
          'GM',
          'GN',
          'GQ',
          'GR',
          'GT',
          'GW',
          'GY',
          'HK',
          'HN',
          'HR',
          'HT',
          'HU',
          'ID',
          'IE',
          'IL',
          'IN',
          'IS',
          'IT',
          'JM',
          'JO',
          'JP',
          'KE',
          'KG',
          'KH',
          'KI',
          'KM',
          'KN',
          'KR',
          'KW',
          'KZ',
          'LA',
          'LB',
          'LC',
          'LI',
          'LK',
          'LR',
          'LS',
          'LT',
          'LU',
          'LV',
          'MA',
          'MC',
          'MD',
          'ME',
          'MH',
          'MK',
          'ML',
          'MN',
          'MO',
          'MR',
          'MT',
          'MV',
          'MW',
          'MX',
          'MY',
          'NA',
          'NE',
          'NG',
          'NI',
          'NL',
          'NO',
          'NR',
          'NZ',
          'OM',
          'PA',
          'PE',
          'PG',
          'PH',
          'PK',
          'PL',
          'PS',
          'PT',
          'PW',
          'PY',
          'QA',
          'RO',
          'RS',
          'RU',
          'RW',
          'SA',
          'SB',
          'SC',
          'SE',
          'SG',
          'SI',
          'SK',
          'SL',
          'SM',
          'SN',
          'SR',
          'ST',
          'SV',
          'SZ',
          'TD',
          'TG',
          'TH',
          'TL',
          'TN',
          'TO',
          'TR',
          'TT',
          'TV',
          'TW',
          'TZ',
          'UA',
          'UG',
          'US',
          'UY',
          'VC',
          'VN',
          'VU',
          'WS',
          'XK',
          'ZA',
          'ZW',
        ],
        disc_number: 1,
        duration_ms: 171573,
        explicit: true,
        external_urls: {
          spotify: 'https://open.spotify.com/track/1TEL6MlSSVLSdhOSddidlJ',
        },
        href: 'https://api.spotify.com/v1/tracks/1TEL6MlSSVLSdhOSddidlJ',
        id: '1TEL6MlSSVLSdhOSddidlJ',
        is_local: false,
        name: 'needy',
        preview_url: null,
        track_number: 2,
        type: 'track',
        uri: 'spotify:track:1TEL6MlSSVLSdhOSddidlJ',
      },
      {
        artists: [
          {
            external_urls: {
              spotify: 'https://open.spotify.com/artist/66CXWjxzNUsdJxJ2JdwvnR',
            },
            href: 'https://api.spotify.com/v1/artists/66CXWjxzNUsdJxJ2JdwvnR',
            id: '66CXWjxzNUsdJxJ2JdwvnR',
            name: 'Ariana Grande',
            type: 'artist',
            uri: 'spotify:artist:66CXWjxzNUsdJxJ2JdwvnR',
          },
        ],
        available_markets: [
          'AD',
          'AE',
          'AG',
          'AL',
          'AM',
          'AR',
          'AT',
          'AU',
          'AZ',
          'BA',
          'BB',
          'BD',
          'BE',
          'BG',
          'BH',
          'BI',
          'BO',
          'BR',
          'BS',
          'BT',
          'BW',
          'BZ',
          'CA',
          'CH',
          'CL',
          'CM',
          'CO',
          'CR',
          'CV',
          'CW',
          'CY',
          'CZ',
          'DE',
          'DK',
          'DM',
          'DO',
          'DZ',
          'EC',
          'EE',
          'EG',
          'ES',
          'FI',
          'FJ',
          'FM',
          'FR',
          'GA',
          'GB',
          'GD',
          'GE',
          'GH',
          'GM',
          'GN',
          'GQ',
          'GR',
          'GT',
          'GW',
          'GY',
          'HK',
          'HN',
          'HR',
          'HT',
          'HU',
          'ID',
          'IE',
          'IL',
          'IN',
          'IS',
          'IT',
          'JM',
          'JO',
          'JP',
          'KE',
          'KG',
          'KH',
          'KI',
          'KM',
          'KN',
          'KR',
          'KW',
          'KZ',
          'LA',
          'LB',
          'LC',
          'LI',
          'LK',
          'LR',
          'LS',
          'LT',
          'LU',
          'LV',
          'MA',
          'MC',
          'MD',
          'ME',
          'MH',
          'MK',
          'ML',
          'MN',
          'MO',
          'MR',
          'MT',
          'MV',
          'MW',
          'MX',
          'MY',
          'NA',
          'NE',
          'NG',
          'NI',
          'NL',
          'NO',
          'NR',
          'NZ',
          'OM',
          'PA',
          'PE',
          'PG',
          'PH',
          'PK',
          'PL',
          'PS',
          'PT',
          'PW',
          'PY',
          'QA',
          'RO',
          'RS',
          'RU',
          'RW',
          'SA',
          'SB',
          'SC',
          'SE',
          'SG',
          'SI',
          'SK',
          'SL',
          'SM',
          'SN',
          'SR',
          'ST',
          'SV',
          'SZ',
          'TD',
          'TG',
          'TH',
          'TL',
          'TN',
          'TO',
          'TR',
          'TT',
          'TV',
          'TW',
          'TZ',
          'UA',
          'UG',
          'US',
          'UY',
          'VC',
          'VN',
          'VU',
          'WS',
          'XK',
          'ZA',
          'ZW',
        ],
        disc_number: 1,
        duration_ms: 182000,
        explicit: false,
        external_urls: {
          spotify: 'https://open.spotify.com/track/4uTvPEr01pjTbZgl7jcKBD',
        },
        href: 'https://api.spotify.com/v1/tracks/4uTvPEr01pjTbZgl7jcKBD',
        id: '4uTvPEr01pjTbZgl7jcKBD',
        is_local: false,
        name: 'NASA',
        preview_url: null,
        track_number: 3,
        type: 'track',
        uri: 'spotify:track:4uTvPEr01pjTbZgl7jcKBD',
      },
      {
        artists: [
          {
            external_urls: {
              spotify: 'https://open.spotify.com/artist/66CXWjxzNUsdJxJ2JdwvnR',
            },
            href: 'https://api.spotify.com/v1/artists/66CXWjxzNUsdJxJ2JdwvnR',
            id: '66CXWjxzNUsdJxJ2JdwvnR',
            name: 'Ariana Grande',
            type: 'artist',
            uri: 'spotify:artist:66CXWjxzNUsdJxJ2JdwvnR',
          },
        ],
        available_markets: [
          'AD',
          'AE',
          'AG',
          'AL',
          'AM',
          'AR',
          'AT',
          'AU',
          'AZ',
          'BA',
          'BB',
          'BD',
          'BE',
          'BG',
          'BH',
          'BI',
          'BO',
          'BR',
          'BS',
          'BT',
          'BW',
          'BZ',
          'CA',
          'CH',
          'CL',
          'CM',
          'CO',
          'CR',
          'CV',
          'CW',
          'CY',
          'CZ',
          'DE',
          'DK',
          'DM',
          'DO',
          'DZ',
          'EC',
          'EE',
          'EG',
          'ES',
          'FI',
          'FJ',
          'FM',
          'FR',
          'GA',
          'GB',
          'GD',
          'GE',
          'GH',
          'GM',
          'GN',
          'GQ',
          'GR',
          'GT',
          'GW',
          'GY',
          'HK',
          'HN',
          'HR',
          'HT',
          'HU',
          'ID',
          'IE',
          'IL',
          'IN',
          'IS',
          'IT',
          'JM',
          'JO',
          'JP',
          'KE',
          'KG',
          'KH',
          'KI',
          'KM',
          'KN',
          'KR',
          'KW',
          'KZ',
          'LA',
          'LB',
          'LC',
          'LI',
          'LK',
          'LR',
          'LS',
          'LT',
          'LU',
          'LV',
          'MA',
          'MC',
          'MD',
          'ME',
          'MH',
          'MK',
          'ML',
          'MN',
          'MO',
          'MR',
          'MT',
          'MV',
          'MW',
          'MX',
          'MY',
          'NA',
          'NE',
          'NG',
          'NI',
          'NL',
          'NO',
          'NR',
          'NZ',
          'OM',
          'PA',
          'PE',
          'PG',
          'PH',
          'PK',
          'PL',
          'PS',
          'PT',
          'PW',
          'PY',
          'QA',
          'RO',
          'RS',
          'RU',
          'RW',
          'SA',
          'SB',
          'SC',
          'SE',
          'SG',
          'SI',
          'SK',
          'SL',
          'SM',
          'SN',
          'SR',
          'ST',
          'SV',
          'SZ',
          'TD',
          'TG',
          'TH',
          'TL',
          'TN',
          'TO',
          'TR',
          'TT',
          'TV',
          'TW',
          'TZ',
          'UA',
          'UG',
          'US',
          'UY',
          'VC',
          'VN',
          'VU',
          'WS',
          'XK',
          'ZA',
          'ZW',
        ],
        disc_number: 1,
        duration_ms: 216893,
        explicit: true,
        external_urls: {
          spotify: 'https://open.spotify.com/track/2hloaUoRonYssMuqLCBLTX',
        },
        href: 'https://api.spotify.com/v1/tracks/2hloaUoRonYssMuqLCBLTX',
        id: '2hloaUoRonYssMuqLCBLTX',
        is_local: false,
        name: 'bloodline',
        preview_url: null,
        track_number: 4,
        type: 'track',
        uri: 'spotify:track:2hloaUoRonYssMuqLCBLTX',
      },
      {
        artists: [
          {
            external_urls: {
              spotify: 'https://open.spotify.com/artist/66CXWjxzNUsdJxJ2JdwvnR',
            },
            href: 'https://api.spotify.com/v1/artists/66CXWjxzNUsdJxJ2JdwvnR',
            id: '66CXWjxzNUsdJxJ2JdwvnR',
            name: 'Ariana Grande',
            type: 'artist',
            uri: 'spotify:artist:66CXWjxzNUsdJxJ2JdwvnR',
          },
        ],
        available_markets: [
          'AD',
          'AE',
          'AG',
          'AL',
          'AM',
          'AR',
          'AT',
          'AU',
          'AZ',
          'BA',
          'BB',
          'BD',
          'BE',
          'BG',
          'BH',
          'BI',
          'BO',
          'BR',
          'BS',
          'BT',
          'BW',
          'BZ',
          'CA',
          'CH',
          'CL',
          'CM',
          'CO',
          'CR',
          'CV',
          'CW',
          'CY',
          'CZ',
          'DE',
          'DK',
          'DM',
          'DO',
          'DZ',
          'EC',
          'EE',
          'EG',
          'ES',
          'FI',
          'FJ',
          'FM',
          'FR',
          'GA',
          'GB',
          'GD',
          'GE',
          'GH',
          'GM',
          'GN',
          'GQ',
          'GR',
          'GT',
          'GW',
          'GY',
          'HK',
          'HN',
          'HR',
          'HT',
          'HU',
          'ID',
          'IE',
          'IL',
          'IN',
          'IS',
          'IT',
          'JM',
          'JO',
          'JP',
          'KE',
          'KG',
          'KH',
          'KI',
          'KM',
          'KN',
          'KR',
          'KW',
          'KZ',
          'LA',
          'LB',
          'LC',
          'LI',
          'LK',
          'LR',
          'LS',
          'LT',
          'LU',
          'LV',
          'MA',
          'MC',
          'MD',
          'ME',
          'MH',
          'MK',
          'ML',
          'MN',
          'MO',
          'MR',
          'MT',
          'MV',
          'MW',
          'MX',
          'MY',
          'NA',
          'NE',
          'NG',
          'NI',
          'NL',
          'NO',
          'NR',
          'NZ',
          'OM',
          'PA',
          'PE',
          'PG',
          'PH',
          'PK',
          'PL',
          'PS',
          'PT',
          'PW',
          'PY',
          'QA',
          'RO',
          'RS',
          'RU',
          'RW',
          'SA',
          'SB',
          'SC',
          'SE',
          'SG',
          'SI',
          'SK',
          'SL',
          'SM',
          'SN',
          'SR',
          'ST',
          'SV',
          'SZ',
          'TD',
          'TG',
          'TH',
          'TL',
          'TN',
          'TO',
          'TR',
          'TT',
          'TV',
          'TW',
          'TZ',
          'UA',
          'UG',
          'US',
          'UY',
          'VC',
          'VN',
          'VU',
          'WS',
          'XK',
          'ZA',
          'ZW',
        ],
        disc_number: 1,
        duration_ms: 208880,
        explicit: true,
        external_urls: {
          spotify: 'https://open.spotify.com/track/3wFLWP0FcIqHK1wb1CPthQ',
        },
        href: 'https://api.spotify.com/v1/tracks/3wFLWP0FcIqHK1wb1CPthQ',
        id: '3wFLWP0FcIqHK1wb1CPthQ',
        is_local: false,
        name: 'fake smile',
        preview_url: null,
        track_number: 5,
        type: 'track',
        uri: 'spotify:track:3wFLWP0FcIqHK1wb1CPthQ',
      },
      {
        artists: [
          {
            external_urls: {
              spotify: 'https://open.spotify.com/artist/66CXWjxzNUsdJxJ2JdwvnR',
            },
            href: 'https://api.spotify.com/v1/artists/66CXWjxzNUsdJxJ2JdwvnR',
            id: '66CXWjxzNUsdJxJ2JdwvnR',
            name: 'Ariana Grande',
            type: 'artist',
            uri: 'spotify:artist:66CXWjxzNUsdJxJ2JdwvnR',
          },
        ],
        available_markets: [
          'AD',
          'AE',
          'AG',
          'AL',
          'AM',
          'AR',
          'AT',
          'AU',
          'AZ',
          'BA',
          'BB',
          'BD',
          'BE',
          'BG',
          'BH',
          'BI',
          'BO',
          'BR',
          'BS',
          'BT',
          'BW',
          'BZ',
          'CA',
          'CH',
          'CL',
          'CM',
          'CO',
          'CR',
          'CV',
          'CW',
          'CY',
          'CZ',
          'DE',
          'DK',
          'DM',
          'DO',
          'DZ',
          'EC',
          'EE',
          'EG',
          'ES',
          'FI',
          'FJ',
          'FM',
          'FR',
          'GA',
          'GB',
          'GD',
          'GE',
          'GH',
          'GM',
          'GN',
          'GQ',
          'GR',
          'GT',
          'GW',
          'GY',
          'HK',
          'HN',
          'HR',
          'HT',
          'HU',
          'ID',
          'IE',
          'IL',
          'IN',
          'IS',
          'IT',
          'JM',
          'JO',
          'JP',
          'KE',
          'KG',
          'KH',
          'KI',
          'KM',
          'KN',
          'KR',
          'KW',
          'KZ',
          'LA',
          'LB',
          'LC',
          'LI',
          'LK',
          'LR',
          'LS',
          'LT',
          'LU',
          'LV',
          'MA',
          'MC',
          'MD',
          'ME',
          'MH',
          'MK',
          'ML',
          'MN',
          'MO',
          'MR',
          'MT',
          'MV',
          'MW',
          'MX',
          'MY',
          'NA',
          'NE',
          'NG',
          'NI',
          'NL',
          'NO',
          'NR',
          'NZ',
          'OM',
          'PA',
          'PE',
          'PG',
          'PH',
          'PK',
          'PL',
          'PS',
          'PT',
          'PW',
          'PY',
          'QA',
          'RO',
          'RS',
          'RU',
          'RW',
          'SA',
          'SB',
          'SC',
          'SE',
          'SG',
          'SI',
          'SK',
          'SL',
          'SM',
          'SN',
          'SR',
          'ST',
          'SV',
          'SZ',
          'TD',
          'TG',
          'TH',
          'TL',
          'TN',
          'TO',
          'TR',
          'TT',
          'TV',
          'TW',
          'TZ',
          'UA',
          'UG',
          'US',
          'UY',
          'VC',
          'VN',
          'VU',
          'WS',
          'XK',
          'ZA',
          'ZW',
        ],
        disc_number: 1,
        duration_ms: 267106,
        explicit: false,
        external_urls: {
          spotify: 'https://open.spotify.com/track/5Il6Oe7lr5XM7A0cWbVQtr',
        },
        href: 'https://api.spotify.com/v1/tracks/5Il6Oe7lr5XM7A0cWbVQtr',
        id: '5Il6Oe7lr5XM7A0cWbVQtr',
        is_local: false,
        name: 'bad idea',
        preview_url: null,
        track_number: 6,
        type: 'track',
        uri: 'spotify:track:5Il6Oe7lr5XM7A0cWbVQtr',
      },
      {
        artists: [
          {
            external_urls: {
              spotify: 'https://open.spotify.com/artist/66CXWjxzNUsdJxJ2JdwvnR',
            },
            href: 'https://api.spotify.com/v1/artists/66CXWjxzNUsdJxJ2JdwvnR',
            id: '66CXWjxzNUsdJxJ2JdwvnR',
            name: 'Ariana Grande',
            type: 'artist',
            uri: 'spotify:artist:66CXWjxzNUsdJxJ2JdwvnR',
          },
        ],
        available_markets: [
          'AD',
          'AE',
          'AG',
          'AL',
          'AM',
          'AR',
          'AT',
          'AU',
          'AZ',
          'BA',
          'BB',
          'BD',
          'BE',
          'BG',
          'BH',
          'BI',
          'BO',
          'BR',
          'BS',
          'BT',
          'BW',
          'BZ',
          'CA',
          'CH',
          'CL',
          'CM',
          'CO',
          'CR',
          'CV',
          'CW',
          'CY',
          'CZ',
          'DE',
          'DK',
          'DM',
          'DO',
          'DZ',
          'EC',
          'EE',
          'EG',
          'ES',
          'FI',
          'FJ',
          'FM',
          'FR',
          'GA',
          'GB',
          'GD',
          'GE',
          'GH',
          'GM',
          'GN',
          'GQ',
          'GR',
          'GT',
          'GW',
          'GY',
          'HK',
          'HN',
          'HR',
          'HT',
          'HU',
          'ID',
          'IE',
          'IL',
          'IN',
          'IS',
          'IT',
          'JM',
          'JO',
          'JP',
          'KE',
          'KG',
          'KH',
          'KI',
          'KM',
          'KN',
          'KR',
          'KW',
          'KZ',
          'LA',
          'LB',
          'LC',
          'LI',
          'LK',
          'LR',
          'LS',
          'LT',
          'LU',
          'LV',
          'MA',
          'MC',
          'MD',
          'ME',
          'MH',
          'MK',
          'ML',
          'MN',
          'MO',
          'MR',
          'MT',
          'MV',
          'MW',
          'MX',
          'MY',
          'NA',
          'NE',
          'NG',
          'NI',
          'NL',
          'NO',
          'NR',
          'NZ',
          'OM',
          'PA',
          'PE',
          'PG',
          'PH',
          'PK',
          'PL',
          'PS',
          'PT',
          'PW',
          'PY',
          'QA',
          'RO',
          'RS',
          'RU',
          'RW',
          'SA',
          'SB',
          'SC',
          'SE',
          'SG',
          'SI',
          'SK',
          'SL',
          'SM',
          'SN',
          'SR',
          'ST',
          'SV',
          'SZ',
          'TD',
          'TG',
          'TH',
          'TL',
          'TN',
          'TO',
          'TR',
          'TT',
          'TV',
          'TW',
          'TZ',
          'UA',
          'UG',
          'US',
          'UY',
          'VC',
          'VN',
          'VU',
          'WS',
          'XK',
          'ZA',
          'ZW',
        ],
        disc_number: 1,
        duration_ms: 140693,
        explicit: true,
        external_urls: {
          spotify: 'https://open.spotify.com/track/27356GVuMPFWiJSZCragoM',
        },
        href: 'https://api.spotify.com/v1/tracks/27356GVuMPFWiJSZCragoM',
        id: '27356GVuMPFWiJSZCragoM',
        is_local: false,
        name: 'make up',
        preview_url: null,
        track_number: 7,
        type: 'track',
        uri: 'spotify:track:27356GVuMPFWiJSZCragoM',
      },
      {
        artists: [
          {
            external_urls: {
              spotify: 'https://open.spotify.com/artist/66CXWjxzNUsdJxJ2JdwvnR',
            },
            href: 'https://api.spotify.com/v1/artists/66CXWjxzNUsdJxJ2JdwvnR',
            id: '66CXWjxzNUsdJxJ2JdwvnR',
            name: 'Ariana Grande',
            type: 'artist',
            uri: 'spotify:artist:66CXWjxzNUsdJxJ2JdwvnR',
          },
        ],
        available_markets: [
          'AD',
          'AE',
          'AG',
          'AL',
          'AM',
          'AR',
          'AT',
          'AU',
          'AZ',
          'BA',
          'BB',
          'BD',
          'BE',
          'BG',
          'BH',
          'BI',
          'BO',
          'BR',
          'BS',
          'BT',
          'BW',
          'BZ',
          'CA',
          'CH',
          'CL',
          'CM',
          'CO',
          'CR',
          'CV',
          'CW',
          'CY',
          'CZ',
          'DE',
          'DK',
          'DM',
          'DO',
          'DZ',
          'EC',
          'EE',
          'EG',
          'ES',
          'FI',
          'FJ',
          'FM',
          'FR',
          'GA',
          'GB',
          'GD',
          'GE',
          'GH',
          'GM',
          'GN',
          'GQ',
          'GR',
          'GT',
          'GW',
          'GY',
          'HK',
          'HN',
          'HR',
          'HT',
          'HU',
          'ID',
          'IE',
          'IL',
          'IN',
          'IS',
          'IT',
          'JM',
          'JO',
          'JP',
          'KE',
          'KG',
          'KH',
          'KI',
          'KM',
          'KN',
          'KR',
          'KW',
          'KZ',
          'LA',
          'LB',
          'LC',
          'LI',
          'LK',
          'LR',
          'LS',
          'LT',
          'LU',
          'LV',
          'MA',
          'MC',
          'MD',
          'ME',
          'MH',
          'MK',
          'ML',
          'MN',
          'MO',
          'MR',
          'MT',
          'MV',
          'MW',
          'MX',
          'MY',
          'NA',
          'NE',
          'NG',
          'NI',
          'NL',
          'NO',
          'NR',
          'NZ',
          'OM',
          'PA',
          'PE',
          'PG',
          'PH',
          'PK',
          'PL',
          'PS',
          'PT',
          'PW',
          'PY',
          'QA',
          'RO',
          'RS',
          'RU',
          'RW',
          'SA',
          'SB',
          'SC',
          'SE',
          'SG',
          'SI',
          'SK',
          'SL',
          'SM',
          'SN',
          'SR',
          'ST',
          'SV',
          'SZ',
          'TD',
          'TG',
          'TH',
          'TL',
          'TN',
          'TO',
          'TR',
          'TT',
          'TV',
          'TW',
          'TZ',
          'UA',
          'UG',
          'US',
          'UY',
          'VC',
          'VN',
          'VU',
          'WS',
          'XK',
          'ZA',
          'ZW',
        ],
        disc_number: 1,
        duration_ms: 271466,
        explicit: false,
        external_urls: {
          spotify: 'https://open.spotify.com/track/2vdBo4ALPYbHRUPKgtE5iC',
        },
        href: 'https://api.spotify.com/v1/tracks/2vdBo4ALPYbHRUPKgtE5iC',
        id: '2vdBo4ALPYbHRUPKgtE5iC',
        is_local: false,
        name: 'ghostin',
        preview_url: null,
        track_number: 8,
        type: 'track',
        uri: 'spotify:track:2vdBo4ALPYbHRUPKgtE5iC',
      },
      {
        artists: [
          {
            external_urls: {
              spotify: 'https://open.spotify.com/artist/66CXWjxzNUsdJxJ2JdwvnR',
            },
            href: 'https://api.spotify.com/v1/artists/66CXWjxzNUsdJxJ2JdwvnR',
            id: '66CXWjxzNUsdJxJ2JdwvnR',
            name: 'Ariana Grande',
            type: 'artist',
            uri: 'spotify:artist:66CXWjxzNUsdJxJ2JdwvnR',
          },
        ],
        available_markets: [
          'AD',
          'AE',
          'AG',
          'AL',
          'AM',
          'AR',
          'AT',
          'AU',
          'AZ',
          'BA',
          'BB',
          'BD',
          'BE',
          'BG',
          'BH',
          'BI',
          'BO',
          'BR',
          'BS',
          'BT',
          'BW',
          'BZ',
          'CA',
          'CH',
          'CL',
          'CM',
          'CO',
          'CR',
          'CV',
          'CW',
          'CY',
          'CZ',
          'DE',
          'DK',
          'DM',
          'DO',
          'DZ',
          'EC',
          'EE',
          'EG',
          'ES',
          'FI',
          'FJ',
          'FM',
          'FR',
          'GA',
          'GB',
          'GD',
          'GE',
          'GH',
          'GM',
          'GN',
          'GQ',
          'GR',
          'GT',
          'GW',
          'GY',
          'HK',
          'HN',
          'HR',
          'HT',
          'HU',
          'ID',
          'IE',
          'IL',
          'IN',
          'IS',
          'IT',
          'JM',
          'JO',
          'JP',
          'KE',
          'KG',
          'KH',
          'KI',
          'KM',
          'KN',
          'KR',
          'KW',
          'KZ',
          'LA',
          'LB',
          'LC',
          'LI',
          'LK',
          'LR',
          'LS',
          'LT',
          'LU',
          'LV',
          'MA',
          'MC',
          'MD',
          'ME',
          'MH',
          'MK',
          'ML',
          'MN',
          'MO',
          'MR',
          'MT',
          'MV',
          'MW',
          'MX',
          'MY',
          'NA',
          'NE',
          'NG',
          'NI',
          'NL',
          'NO',
          'NR',
          'NZ',
          'OM',
          'PA',
          'PE',
          'PG',
          'PH',
          'PK',
          'PL',
          'PS',
          'PT',
          'PW',
          'PY',
          'QA',
          'RO',
          'RS',
          'RU',
          'RW',
          'SA',
          'SB',
          'SC',
          'SE',
          'SG',
          'SI',
          'SK',
          'SL',
          'SM',
          'SN',
          'SR',
          'ST',
          'SV',
          'SZ',
          'TD',
          'TG',
          'TH',
          'TL',
          'TN',
          'TO',
          'TR',
          'TT',
          'TV',
          'TW',
          'TZ',
          'UA',
          'UG',
          'US',
          'UY',
          'VC',
          'VN',
          'VU',
          'WS',
          'XK',
          'ZA',
          'ZW',
        ],
        disc_number: 1,
        duration_ms: 222946,
        explicit: true,
        external_urls: {
          spotify: 'https://open.spotify.com/track/4T652DlATVHe0jdLKaN3Bw',
        },
        href: 'https://api.spotify.com/v1/tracks/4T652DlATVHe0jdLKaN3Bw',
        id: '4T652DlATVHe0jdLKaN3Bw',
        is_local: false,
        name: 'in my head',
        preview_url: null,
        track_number: 9,
        type: 'track',
        uri: 'spotify:track:4T652DlATVHe0jdLKaN3Bw',
      },
      {
        artists: [
          {
            external_urls: {
              spotify: 'https://open.spotify.com/artist/66CXWjxzNUsdJxJ2JdwvnR',
            },
            href: 'https://api.spotify.com/v1/artists/66CXWjxzNUsdJxJ2JdwvnR',
            id: '66CXWjxzNUsdJxJ2JdwvnR',
            name: 'Ariana Grande',
            type: 'artist',
            uri: 'spotify:artist:66CXWjxzNUsdJxJ2JdwvnR',
          },
        ],
        available_markets: [
          'AD',
          'AE',
          'AG',
          'AL',
          'AM',
          'AR',
          'AT',
          'AU',
          'AZ',
          'BA',
          'BB',
          'BD',
          'BE',
          'BG',
          'BH',
          'BI',
          'BO',
          'BR',
          'BS',
          'BT',
          'BW',
          'BZ',
          'CA',
          'CH',
          'CL',
          'CM',
          'CO',
          'CR',
          'CV',
          'CW',
          'CY',
          'CZ',
          'DE',
          'DK',
          'DM',
          'DO',
          'DZ',
          'EC',
          'EE',
          'EG',
          'ES',
          'FI',
          'FJ',
          'FM',
          'FR',
          'GA',
          'GB',
          'GD',
          'GE',
          'GH',
          'GM',
          'GN',
          'GQ',
          'GR',
          'GT',
          'GW',
          'GY',
          'HK',
          'HN',
          'HR',
          'HT',
          'HU',
          'ID',
          'IE',
          'IL',
          'IN',
          'IS',
          'IT',
          'JM',
          'JO',
          'JP',
          'KE',
          'KG',
          'KH',
          'KI',
          'KM',
          'KN',
          'KR',
          'KW',
          'KZ',
          'LA',
          'LB',
          'LC',
          'LI',
          'LK',
          'LR',
          'LS',
          'LT',
          'LU',
          'LV',
          'MA',
          'MC',
          'MD',
          'ME',
          'MH',
          'MK',
          'ML',
          'MN',
          'MO',
          'MR',
          'MT',
          'MV',
          'MW',
          'MX',
          'MY',
          'NA',
          'NE',
          'NG',
          'NI',
          'NL',
          'NO',
          'NR',
          'NZ',
          'OM',
          'PA',
          'PE',
          'PG',
          'PH',
          'PK',
          'PL',
          'PS',
          'PT',
          'PW',
          'PY',
          'QA',
          'RO',
          'RS',
          'RU',
          'RW',
          'SA',
          'SB',
          'SC',
          'SE',
          'SG',
          'SI',
          'SK',
          'SL',
          'SM',
          'SN',
          'SR',
          'ST',
          'SV',
          'SZ',
          'TD',
          'TG',
          'TH',
          'TL',
          'TN',
          'TO',
          'TR',
          'TT',
          'TV',
          'TW',
          'TZ',
          'UA',
          'UG',
          'US',
          'UY',
          'VC',
          'VN',
          'VU',
          'WS',
          'XK',
          'ZA',
          'ZW',
        ],
        disc_number: 1,
        duration_ms: 178626,
        explicit: true,
        external_urls: {
          spotify: 'https://open.spotify.com/track/6ocbgoVGwYJhOv1GgI9NsF',
        },
        href: 'https://api.spotify.com/v1/tracks/6ocbgoVGwYJhOv1GgI9NsF',
        id: '6ocbgoVGwYJhOv1GgI9NsF',
        is_local: false,
        name: '7 rings',
        preview_url: null,
        track_number: 10,
        type: 'track',
        uri: 'spotify:track:6ocbgoVGwYJhOv1GgI9NsF',
      },
      {
        artists: [
          {
            external_urls: {
              spotify: 'https://open.spotify.com/artist/66CXWjxzNUsdJxJ2JdwvnR',
            },
            href: 'https://api.spotify.com/v1/artists/66CXWjxzNUsdJxJ2JdwvnR',
            id: '66CXWjxzNUsdJxJ2JdwvnR',
            name: 'Ariana Grande',
            type: 'artist',
            uri: 'spotify:artist:66CXWjxzNUsdJxJ2JdwvnR',
          },
        ],
        available_markets: [
          'AD',
          'AE',
          'AG',
          'AL',
          'AM',
          'AR',
          'AT',
          'AU',
          'AZ',
          'BA',
          'BB',
          'BD',
          'BE',
          'BG',
          'BH',
          'BI',
          'BO',
          'BR',
          'BS',
          'BT',
          'BW',
          'BZ',
          'CA',
          'CH',
          'CL',
          'CM',
          'CO',
          'CR',
          'CV',
          'CW',
          'CY',
          'CZ',
          'DE',
          'DK',
          'DM',
          'DO',
          'DZ',
          'EC',
          'EE',
          'EG',
          'ES',
          'FI',
          'FJ',
          'FM',
          'FR',
          'GA',
          'GB',
          'GD',
          'GE',
          'GH',
          'GM',
          'GN',
          'GQ',
          'GR',
          'GT',
          'GW',
          'GY',
          'HK',
          'HN',
          'HR',
          'HT',
          'HU',
          'ID',
          'IE',
          'IL',
          'IN',
          'IS',
          'IT',
          'JM',
          'JO',
          'JP',
          'KE',
          'KG',
          'KH',
          'KI',
          'KM',
          'KN',
          'KR',
          'KW',
          'KZ',
          'LA',
          'LB',
          'LC',
          'LI',
          'LK',
          'LR',
          'LS',
          'LT',
          'LU',
          'LV',
          'MA',
          'MC',
          'MD',
          'ME',
          'MH',
          'MK',
          'ML',
          'MN',
          'MO',
          'MR',
          'MT',
          'MV',
          'MW',
          'MX',
          'MY',
          'NA',
          'NE',
          'NG',
          'NI',
          'NL',
          'NO',
          'NR',
          'NZ',
          'OM',
          'PA',
          'PE',
          'PG',
          'PH',
          'PK',
          'PL',
          'PS',
          'PT',
          'PW',
          'PY',
          'QA',
          'RO',
          'RS',
          'RU',
          'RW',
          'SA',
          'SB',
          'SC',
          'SE',
          'SG',
          'SI',
          'SK',
          'SL',
          'SM',
          'SN',
          'SR',
          'ST',
          'SV',
          'SZ',
          'TD',
          'TG',
          'TH',
          'TL',
          'TN',
          'TO',
          'TR',
          'TT',
          'TV',
          'TW',
          'TZ',
          'UA',
          'UG',
          'US',
          'UY',
          'VC',
          'VN',
          'VU',
          'WS',
          'XK',
          'ZA',
          'ZW',
        ],
        disc_number: 1,
        duration_ms: 207320,
        explicit: true,
        external_urls: {
          spotify: 'https://open.spotify.com/track/3e9HZxeyfWwjeyPAMmWSSQ',
        },
        href: 'https://api.spotify.com/v1/tracks/3e9HZxeyfWwjeyPAMmWSSQ',
        id: '3e9HZxeyfWwjeyPAMmWSSQ',
        is_local: false,
        name: 'thank u, next',
        preview_url: null,
        track_number: 11,
        type: 'track',
        uri: 'spotify:track:3e9HZxeyfWwjeyPAMmWSSQ',
      },
      {
        artists: [
          {
            external_urls: {
              spotify: 'https://open.spotify.com/artist/66CXWjxzNUsdJxJ2JdwvnR',
            },
            href: 'https://api.spotify.com/v1/artists/66CXWjxzNUsdJxJ2JdwvnR',
            id: '66CXWjxzNUsdJxJ2JdwvnR',
            name: 'Ariana Grande',
            type: 'artist',
            uri: 'spotify:artist:66CXWjxzNUsdJxJ2JdwvnR',
          },
        ],
        available_markets: [
          'AD',
          'AE',
          'AG',
          'AL',
          'AM',
          'AR',
          'AT',
          'AU',
          'AZ',
          'BA',
          'BB',
          'BD',
          'BE',
          'BG',
          'BH',
          'BI',
          'BO',
          'BR',
          'BS',
          'BT',
          'BW',
          'BZ',
          'CA',
          'CH',
          'CL',
          'CM',
          'CO',
          'CR',
          'CV',
          'CW',
          'CY',
          'CZ',
          'DE',
          'DK',
          'DM',
          'DO',
          'DZ',
          'EC',
          'EE',
          'EG',
          'ES',
          'FI',
          'FJ',
          'FM',
          'FR',
          'GA',
          'GB',
          'GD',
          'GE',
          'GH',
          'GM',
          'GN',
          'GQ',
          'GR',
          'GT',
          'GW',
          'GY',
          'HK',
          'HN',
          'HR',
          'HT',
          'HU',
          'ID',
          'IE',
          'IL',
          'IN',
          'IS',
          'IT',
          'JM',
          'JO',
          'JP',
          'KE',
          'KG',
          'KH',
          'KI',
          'KM',
          'KN',
          'KR',
          'KW',
          'KZ',
          'LA',
          'LB',
          'LC',
          'LI',
          'LK',
          'LR',
          'LS',
          'LT',
          'LU',
          'LV',
          'MA',
          'MC',
          'MD',
          'ME',
          'MH',
          'MK',
          'ML',
          'MN',
          'MO',
          'MR',
          'MT',
          'MV',
          'MW',
          'MX',
          'MY',
          'NA',
          'NE',
          'NG',
          'NI',
          'NL',
          'NO',
          'NR',
          'NZ',
          'OM',
          'PA',
          'PE',
          'PG',
          'PH',
          'PK',
          'PL',
          'PS',
          'PT',
          'PW',
          'PY',
          'QA',
          'RO',
          'RS',
          'RU',
          'RW',
          'SA',
          'SB',
          'SC',
          'SE',
          'SG',
          'SI',
          'SK',
          'SL',
          'SM',
          'SN',
          'SR',
          'ST',
          'SV',
          'SZ',
          'TD',
          'TG',
          'TH',
          'TL',
          'TN',
          'TO',
          'TR',
          'TT',
          'TV',
          'TW',
          'TZ',
          'UA',
          'UG',
          'US',
          'UY',
          'VC',
          'VN',
          'VU',
          'WS',
          'XK',
          'ZA',
          'ZW',
        ],
        disc_number: 1,
        duration_ms: 190440,
        explicit: true,
        external_urls: {
          spotify: 'https://open.spotify.com/track/4kV4N9D1iKVxx1KLvtTpjS',
        },
        href: 'https://api.spotify.com/v1/tracks/4kV4N9D1iKVxx1KLvtTpjS',
        id: '4kV4N9D1iKVxx1KLvtTpjS',
        is_local: false,
        name: "break up with your girlfriend, i'm bored",
        preview_url: null,
        track_number: 12,
        type: 'track',
        uri: 'spotify:track:4kV4N9D1iKVxx1KLvtTpjS',
      },
    ],
    limit: 50,
    next: null,
    offset: 0,
    previous: null,
    total: 12,
  },
  type: 'album',
  uri: 'spotify:album:2fYhqwDWXjbpjaIJPEfKFw',
};
